"use strict";

jQuery(window).on("load", function(){
  
    var getProductTitle = jQuery(".tt-product-single-info h1.tt-title").text();
  
    jQuery(document).on("click", ".tt-options-swatch li a", function(){
        var getVariantAttr = $(this).attr("data-value");
        jQuery(".tt-product-single-info h1.tt-title").text(getProductTitle + " — " + getVariantAttr);
      	var url_string = location.href;
        var url = new URL(url_string);
        var c = url.searchParams.get("variant");
      	var getId = "#keitoya-metafielder #keitoya-"+c;
      	jQuery("span[data-variant-description]").html(jQuery(getId).html());
    });
  	
    var getVariantAttrLoad = $(".tt-options-swatch li.active a.options-color").eq(0).attr("data-value");
    
  	if (getVariantAttrLoad !== undefined) {
        jQuery(".tt-product-single-info h1.tt-title").text(getProductTitle + " — " + getVariantAttrLoad);
        var url_string_load = location.href;
        var url_load = new URL(url_string_load);
        var c_load = url_load.searchParams.get("variant");
        var getId_load = "#keitoya-metafielder #keitoya-"+c_load;
        jQuery("span[data-variant-description]").html(jQuery(getId_load).html());
    }
  
});